import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TGetContractorPaymentRequestSchema,
  TGetContractorPaymentResponseSchema,
} from "./getContractorPayment.schema";

export const getContractorPayment = (axios: IAxiosInstance) => {
  return async (params: TGetContractorPaymentRequestSchema) => {
    const response = await axios.noRetry.get<
      IApiResponse<TGetContractorPaymentResponseSchema>
    >(`/api/getContractorPayment`, {
      params,
    });
    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
